export const darkTheme = {
    name: "dark",
    bg: {
        page: "#060d1a",
        card: "rgba(15,23,42,0.85)",
        cardHover: "rgba(15,23,42,0.95)",
        input: "rgba(255,255,255,0.05)",
        modal: "#0f172a",
        header: "rgba(255,255,255,0.02)",
        row: "rgba(255,255,255,0.01)",
        rowAlt: "transparent",
        tag: "rgba(255,255,255,0.06)",
        overlay: "rgba(0,0,0,0.75)",
        theadRow: "rgba(255,255,255,0.04)",
        metricCard: "rgba(255,255,255,0.03)",
        toggle: "rgba(255,255,255,0.05)",
        toggleActive: "rgba(255,255,255,0.15)",
    },
    border: {
        default: "rgba(255,255,255,0.08)",
        subtle: "rgba(255,255,255,0.05)",
        input: "rgba(255,255,255,0.10)",
        card: "rgba(255,255,255,0.07)",
        divider: "rgba(255,255,255,0.06)",
    },
    text: {
        primary: "#f1f5f9",
        secondary: "#94a3b8",
        muted: "#64748b",
        placeholder: "#475569",
        label: "#64748b",
        inverse: "#0f172a",
    },
    accent: {
        blue: "#60a5fa",
        blueBg: "rgba(96,165,250,0.1)",
        blueBorder: "rgba(96,165,250,0.4)",
        green: "#00ff9d",
        greenBg: "rgba(0,255,157,0.12)",
        yellow: "#fbbf24",
        yellowBg: "rgba(251,191,36,0.12)",
        red: "#f87171",
        redBg: "rgba(248,113,113,0.12)",
        purple: "#a78bfa",
        purpleBg: "rgba(167,139,250,0.12)",
    },
    chart: {
        grid: "rgba(255,255,255,0.05)",
        axis: "#64748b",
        tooltip: { bg: "#1e293b", border: "rgba(255,255,255,0.1)" },
    },
    shadow: {
        card: "0 4px 24px rgba(0,0,0,0.3)",
        modal: "0 25px 80px rgba(0,0,0,0.6)",
        btn: "0 4px 16px rgba(99,102,241,0.3)",
    },
    scrollbar: {
        track: "rgba(255,255,255,0.02)",
        thumb: "rgba(255,255,255,0.10)",
    },
};

export const lightTheme = {
    name: "light",
    bg: {
        page: "#f0f4f8",
        card: "#ffffff",
        cardHover: "#fafbfc",
        input: "#ffffff",
        modal: "#ffffff",
        header: "#f8fafc",
        row: "#f8fafc",
        rowAlt: "transparent",
        tag: "#e2e8f0",
        overlay: "rgba(15,23,42,0.55)",
        theadRow: "#f1f5f9",
        metricCard: "#f8fafc",
        toggle: "#e2e8f0",
        toggleActive: "#cbd5e1",
    },
    border: {
        default: "#e2e8f0",
        subtle: "#f1f5f9",
        input: "#cbd5e1",
        card: "#e2e8f0",
        divider: "#f1f5f9",
    },
    text: {
        primary: "#0f172a",
        secondary: "#475569",
        muted: "#94a3b8",
        placeholder: "#94a3b8",
        label: "#64748b",
        inverse: "#f1f5f9",
    },
    accent: {
        blue: "#2563eb",
        blueBg: "#eff6ff",
        blueBorder: "#93c5fd",
        green: "#059669",
        greenBg: "#ecfdf5",
        yellow: "#d97706",
        yellowBg: "#fffbeb",
        red: "#dc2626",
        redBg: "#fef2f2",
        purple: "#7c3aed",
        purpleBg: "#f5f3ff",
    },
    chart: {
        grid: "#e2e8f0",
        axis: "#94a3b8",
        tooltip: { bg: "#ffffff", border: "#e2e8f0" },
    },
    shadow: {
        card: "0 1px 8px rgba(15,23,42,0.08), 0 4px 16px rgba(15,23,42,0.04)",
        modal: "0 20px 60px rgba(15,23,42,0.2)",
        btn: "0 4px 14px rgba(37,99,235,0.25)",
    },
    scrollbar: {
        track: "#f1f5f9",
        thumb: "#cbd5e1",
    },
};

export const STATUS_COLORS = {
    running: { label: "Çalışıyor", color: "#059669", bg: "#ecfdf5", dark: { color: "#00ff9d", bg: "rgba(0,255,157,0.12)" } },
    idle: { label: "Boşta", color: "#d97706", bg: "#fffbeb", dark: { color: "#fbbf24", bg: "rgba(251,191,36,0.12)" } },
    maintenance: { label: "Bakım", color: "#2563eb", bg: "#eff6ff", dark: { color: "#60a5fa", bg: "rgba(96,165,250,0.12)" } },
    fault: { label: "Arıza", color: "#dc2626", bg: "#fef2f2", dark: { color: "#f87171", bg: "rgba(248,113,113,0.12)" } },
    stopped: { label: "Durduruldu", color: "#64748b", bg: "#f8fafc", dark: { color: "#94a3b8", bg: "rgba(148,163,184,0.12)" } },
};

export const getStatusColors = (status, themeName = "dark") => {
    const cfg = STATUS_COLORS[status] || STATUS_COLORS.stopped;
    if (themeName === "light") return { color: cfg.color, bg: cfg.bg };
    return cfg.dark;
};
